export default "__VITE_ASSET__b8633683__"